/**
 * IQueue<T> 
 * Interface for a simple queue.
 */
export interface IQueue<T> {
  enqueue(item: T): void;
  dequeue(): T | undefined;
  get size(): number;
}

/** 
 * Queue<T> 
 * A simple queue implementation.
 */
export class Queue<T> implements IQueue<T> {
  private storage: T[] = [];

  constructor(private capacity: number = Infinity) {}

  enqueue(item: T): void {
    if (this.size === this.capacity) {
      throw Error("Queue has reached max capacity, you cannot add more items");
    }
    this.storage.push(item);
  }
  dequeue(): T | undefined {
    return this.storage.shift();
  }
  get size(): number {
    return this.storage.length;
  }
}
